module.exports = __webpack_public_path__ + "img/img_beneficio3.ce08eb95.png";